module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.5.6-119.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.5.6.md
// module id = 536
// module chunks = 273